/**
 * @author
 * David Rivera (jherax)
 * https://github.com/jherax
 */

/**
 * @public
 * Generates a random integer between `min` and `max`
 *
 * @param  {Number} min: minimum value (inclusive)
 * @param  {Number} max: maximum value (inclusive)
 * @return {Number}
 */
export default function randomInt(min, max) {
  return Math.floor(Math.random() * (1 + max - min)) + min;
}
